import React, { useEffect } from 'react';

const ListingsAdBanner = () => {
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.log(err);
    }
  }, []);
  return (
    <ins
      className="adsbygoogle"
      style={{
        display: 'block',
      }}
      data-ad-format="fluid"
      data-ad-layout-key="+2v+q2+28-29+82"
      data-ad-client="ca-pub-3539874847561243"
      data-ad-slot="5602549032"
    />
  );
};

export default ListingsAdBanner;
